import { Header, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'

export const LineItemFulfilmentCustomerHeaderView = () => {
  const t = useT()
  return (
    <>
      <Header level="4" type="sub-heading">
        {t('Add a customer to the sale')}
      </Header>
      <Text type="body">
        {t(
          'Contact information will be used to reach out to the customer about the sale.'
        )}
      </Text>
    </>
  )
}
